import { Checkbox, Input, Select } from "antd";
import { useState } from "react";
import { svg } from "../../../../Assets/svg";
import { calculateAll, DriveInOutputsType } from "./driveInCalculations";
import {
  profileMenuOptions,
  profileOptionsForAll,
  profileOptionsForOption1,
  profileOptionsForOption2,
} from "./driveInData";
import { generateExcel } from "./driveInExcel";

const DriveIn = () => {
  const [edit1, setEdit1] = useState("");
  const [edit2, setEdit2] = useState("");
  const [edit3, setEdit3] = useState("");
  const [edit4, setEdit4] = useState("1000");
  const [edit5, setEdit5] = useState("1400");
  const [edit6, setEdit6] = useState("1200");
  const [edit7, setEdit7] = useState("");
  const [edit9, setEdit9] = useState("");
  const [edit27, setEdit27] = useState("");
  const [edit28, setEdit28] = useState("");
  const [edit29, setEdit29] = useState("");
  const [edit31, setEdit31] = useState("");
  const [edit34, setEdit34] = useState("");
  const [edit36, setEdit36] = useState("");
  const [edit37, setEdit37] = useState("");
  const [edit38, setEdit38] = useState("");
  const [edit39, setEdit39] = useState("");
  const [popupmenu3, setPopupmenu3] = useState(1);
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);
  const [optionsMenu, setOptionsMenu] = useState(1);
  const [out, setOut] = useState<DriveInOutputsType | null>(null);
  const [warnings, setWarnings] = useState<string[]>([]);

  const selectedProfileOptions =
    Number(optionsMenu) === 3
      ? profileOptionsForOption2
      : Number(optionsMenu) === 2
        ? profileOptionsForOption1
        : profileOptionsForAll;

  const handleCalculate = () => {
    const inputs = {
      edit1,
      edit2,
      edit3,
      edit4,
      edit5,
      edit6,
      edit7,
      edit9,
      edit27,
      edit28,
      edit29,
      edit31,
      edit34,
      edit36,
      edit37,
      edit38,
      edit39,
      popupmenu3,
      checkbox1,
      checkbox2,
      checkbox3,
      checkbox4,
    };

    try {
      const res = calculateAll(inputs);
      setOut(res);
      setWarnings(res.warnings || []);
    } catch (err) {
      setOut({
        text33: "Calculation failed - see console",
      } as DriveInOutputsType);
      setWarnings([String(err)]);
    }
  };

  const handleReset = () => {
    setEdit1("");
    setEdit2("");
    setEdit3("");
    setEdit4("1000");
    setEdit5("1400");
    setEdit6("1200");
    setEdit7("");
    setEdit9("");
    setEdit27("");
    setEdit28("");
    setEdit29("");
    setEdit31("");
    setEdit34("");
    setEdit36("");
    setEdit37("");
    setEdit38("");
    setEdit39("");
    setPopupmenu3(1);
    setCheckbox1(false);
    setCheckbox2(false);
    setCheckbox3(false);
    setCheckbox4(false);
    setOut(null);
    setWarnings([]);
  };

  const handleDownloadExcel = () => {
    if (!out) return;

    const customProfileInputs =
      popupmenu3 === 2
        ? {
          "Custom Uprights: Area (A)": edit34,
          "Custom Uprights: Ixx": edit36,
          "Custom Uprights: Iyy": edit37,
          "Custom Uprights: X": edit38,
          "Custom Uprights: Y": edit39,
        }
        : {};

    const payload = {
      inputs: {
        Uprights: selectedProfileOptions?.find(
          (item) => item?.value === Number(popupmenu3),
        )?.label,
        ...customProfileInputs,
        "No. Beam Levels": edit1,
        "Pallet Height": edit2,
        "Pallet Weight": edit3,
        "Pallets Deep": edit7,
        "Pallet Depth": edit4,
        "Aisle Width": edit5,
        "Pallet Width": edit6,
        "Different Space 1st Level": edit28,
        "% Side Load": edit31,
        APR: String(checkbox1),
        BIP: String(checkbox2),
        Reinforcement: String(checkbox3),
        "Cantilever Offset": String(checkbox4),
        "Change Width Frames": edit9,
        "Change Width APR": edit27,
        "Specify Height Frames": edit29,
      },
      outputs: {
        "Depth Structure": out.text40 || "0",
        "Gap Between Frames": out.text45 || "0",
        "Number Frames": out.text46 || "0",
        "Width Frames": out.text42 || "0",
        "Number APR": out.text50 || "0",
        "Width APR": out.text51 || "0",
        "Number BIP": out.text47 || "0",
        "Height Frames": out.text43 || "0",
        "% Load Used At Base": out.text49 || "0",
        "% Side Load": out.text44 || "0",
        FOS: out.text60 || "0",
      },
      warnings: out.warnings || [],
      technical: out.technical || {},
    };
    generateExcel(payload, "drive_in_results.xlsx");
  };

  return (
    <div className="p-4">
      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Uprights Options</label>
            <Select
              placeholder="Uprights Options"
              onChange={(e) => {
                setOptionsMenu(e);
                setPopupmenu3(1);
              }}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
              options={profileMenuOptions}
              value={optionsMenu}
            />
          </div>
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <div className="form-item">
            <label className="custom-label mb-1 ff">Uprights</label>
            <Select
              key={selectedProfileOptions.length}
              placeholder="Uprights"
              onChange={(e) => {
                setPopupmenu3(e);
              }}
              optionFilterProp="children"
              popupClassName="user-dropdown"
              virtual={false}
              suffixIcon={svg?.selectDownArrow}
            >
              {selectedProfileOptions?.map((o) => (
                <Select.Option key={o.value}>{o.label}</Select.Option>
              ))}
            </Select>
          </div>
        </div>
      </div>

      {Number(popupmenu3) === 2 && (
        <div className="row gy-3 page-form mb-3">
          <div className="col-lg-2 col-md-3 col-sm-6">
            <label className="custom-label mb-1 ff">Custom A</label>
            <Input
              className="form-control form-control-lg"
              type="number"
              value={edit34}
              onChange={(e) => setEdit34(e.target.value)}
              disabled={Number(popupmenu3) !== 2}
              placeholder="0"
            />
          </div>

          <div className="col-lg-2 col-md-3 col-sm-6">
            <label className="custom-label mb-1 ff">Custom Ixx</label>
            <Input
              className="form-control form-control-lg"
              type="number"
              value={edit36}
              onChange={(e) => setEdit36(e.target.value)}
              disabled={Number(popupmenu3) !== 2}
              placeholder="0"
            />
          </div>

          <div className="col-lg-2 col-md-3 col-sm-6">
            <label className="custom-label mb-1 ff">Custom Iyy</label>
            <Input
              className="form-control form-control-lg"
              type="number"
              value={edit37}
              onChange={(e) => setEdit37(e.target.value)}
              disabled={Number(popupmenu3) !== 2}
              placeholder="0"
            />
          </div>

          <div className="col-lg-2 col-md-3 col-sm-6">
            <label className="custom-label mb-1 ff">Custom X</label>
            <Input
              className="form-control form-control-lg"
              type="number"
              value={edit38}
              onChange={(e) => setEdit38(e.target.value)}
              disabled={Number(popupmenu3) !== 2}
              placeholder="0"
            />
          </div>

          <div className="col-lg-2 col-md-3 col-sm-6">
            <label className="custom-label mb-1 ff">Custom Y</label>
            <Input
              className="form-control form-control-lg"
              type="number"
              value={edit39}
              onChange={(e) => setEdit39(e.target.value)}
              disabled={Number(popupmenu3) !== 2}
              placeholder="0"
            />
          </div>
        </div>
      )}

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">No. Beam Levels</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit1}
            onChange={(e) => setEdit1(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Pallet Height</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit2}
            onChange={(e) => setEdit2(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Pallet Weight</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit3}
            onChange={(e) => setEdit3(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Pallets Deep</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit7}
            onChange={(e) => setEdit7(e.target.value)}
            placeholder="0"
          />
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Pallet Depth</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit4}
            onChange={(e) => setEdit4(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Aisle Width</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit5}
            onChange={(e) => setEdit5(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Pallet Width</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit6}
            onChange={(e) => setEdit6(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">
            Different Space 1st level
          </label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit28}
            onChange={(e) => setEdit28(e.target.value)}
            placeholder="0"
          />
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">% Side Load</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit31}
            onChange={(e) => setEdit31(e.target.value)}
            placeholder="0"
          />
        </div>


      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-2 col-md-3 col-sm-6">
          <Checkbox
            checked={checkbox1}
            onChange={(e) => setCheckbox1(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            APR
          </Checkbox>
        </div>

        <div className="col-lg-2 col-md-3 col-sm-6">
          <Checkbox
            checked={checkbox2}
            onChange={(e) => setCheckbox2(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            BIP
          </Checkbox>
        </div>

        <div className="col-lg-2 col-md-3 col-sm-6">
          <Checkbox
            checked={checkbox3}
            onChange={(e) => setCheckbox3(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            Reinforcement
          </Checkbox>
        </div>

        <div className="col-lg-2 col-md-3 col-sm-6">
          <Checkbox
            checked={checkbox4}
            onChange={(e) => setCheckbox4(e.target.checked)}
            className="fw-bold fs-6 custom-checkbox"
          >
            Cantilever Offset
          </Checkbox>
        </div>
      </div>

      <div className="row gy-3 page-form mb-3">
        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Change Width Frames</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit9}
            onChange={(e) => setEdit9(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Change Width APR</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit27}
            onChange={(e) => setEdit27(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="col-lg-3 col-md-4 col-sm-6">
          <label className="custom-label mb-1 ff">Specify Height Frames</label>
          <Input
            className="form-control form-control-lg"
            type="number"
            value={edit29}
            onChange={(e) => setEdit29(e.target.value)}
            placeholder="0"
          />
        </div>
      </div>
      <div className="row mt-md-4 mt-3 gy-2">
        <div className="col-md-auto">
          <button
            onClick={handleCalculate}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            CALCULATE NOW
          </button>
        </div>
        <div className="col-md-auto col-sm-6">
          <button
            onClick={handleDownloadExcel}
            disabled={!out}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            DOWNLOAD EXCEL
          </button>
        </div>
        <div className="col-md-auto col-sm-6">
          <button
            onClick={handleReset}
            className="btn btn-lg btn-primary px-4 w-100"
          >
            RESET
          </button>
        </div>
      </div>


      <hr className="opacity-100 mb-4" />

      <h3>Results</h3>

      {out ? (
        <div className="row gy-md-2 gy-1 align-items-end mt-2">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">Depth Structure: {out.text40 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">
              Gap Between Frames: {out.text45 || "0"}
            </p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">Number Frames: {out.text46 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">Width Frames: {out.text42 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">Number APR: {out.text50 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">Width APR: {out.text51 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">Number BIP: {out.text47 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">Height Frames: {out.text43 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">
              % Load Used At Base: {out.text49 || "0"}
            </p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">% Side Load: {out.text44 || "0"}</p>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <p className="custom-label">FOS: {out.text60 || "0"}</p>
          </div>
        </div>
      ) : (
        <p className="custom-label text-949494">
          No results — press CALCULATE NOW.
        </p>
      )}
      {warnings && warnings.length > 0 ? (
        <div className="my-2 space-y-1">
          {warnings.map((w, i) => (
            <div key={i} className="mt-3">
              <span className="custom-label text-949494">⚠️ {w}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default DriveIn;
